module.exports = __webpack_public_path__ + "img/samsungxcasetify.0f12113f.jpg";